import React, { useState, useEffect } from "react";
import { TreeSelect } from "primereact/treeselect";
import { ProgressSpinner } from "primereact/progressspinner";
import { postAPICall } from "../Api/Api";
import { useLoader } from "../GlobalComponents/Loader";

export default function LookupviewTree(props) {
  const [selectedName, setSelectedName] = useState(null);
  const [data, setData] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState("0:1:7");
  const [loading, setLoading] = useState(false); // State for tracking loading status
           const { showLoader, hideLoader } = useLoader();
   
  useEffect(() => {
    LookUpTreeViewFetchData();
  }, [props]);

  const LookUpTreeViewFetchData = async () => {
    showLoader()
    let AccountGroupCode = localStorage.getItem("AccountGroupCode");
    const requestBody = {
      companyID: "1",
      AccountGroupCode: AccountGroupCode,
    };
    const response = await postAPICall(
      "api/Global/HAPLiveHeirarchy",
      requestBody
    );

    if (response?.status === 200) {
      hideLoader()
      const transformedData = transformData(response.data);
      setData(transformedData);
    } else {
      setData([]);
    }
    hideLoader()
    setLoading(false); // Set loading to false after data fetching is complete
  };

  function onSelectionChanged(e) {
    setLoading(true);
    setSelectedName(e.value);
    let gettreeID = e.value || "";
    if (gettreeID !== undefined) props.ontreeselection(gettreeID);
  }

  //PARTHI BEFORE CAHNGES - node key level 3
  // const transformData = (data) => {
  //   const treeData = [];
  //   //const expandedKeysObject = {};
  //   const rootId = 0; // Define the root node ID

  //   const processNode = (node) => {
  //     const children = data.filter((item) => item.parentid === node.id);
  //     return {
  //       key: node.id.toString(),
  //       label: node.name,
  //       children: children.length > 0 ? children.map(processNode) : null,
  //     };
  //   };

  //   // Find the root node
  //   const rootNode = data.find((item) => item.parentid === rootId);
  //   if (!rootNode) {
  //     console.error("Root node not found.");
  //     return treeData; // Return empty treeData if root node is not found
  //   }
  //   treeData.push(processNode(rootNode));
  //   return treeData;
  // };
  const transformData = (data) => {
    const treeData = [];
    const rootId = 0; // Define the root node ID

    const processNode = (node, level) => {
      const children = data?.filter((item) => item.parentid === node.id);
      return {
        key: node.id.toString(),
        label: node.name,
        children:
          children.length > 0
            ? children.map((child) => processNode(child, level + 1))
            : null,
        expanded: level < 3, // Expand up to level 3
      };
    };

    // Find the root node
    const rootNode = data.find((item) => item.parentid === rootId);
    if (!rootNode) {
      console.error("Root node not found.");
      return treeData; // Return empty treeData if root node is not found
    }
    treeData.push(processNode(rootNode, 1)); // Start processing from level 1
    return treeData;
  };

  return (
    <div className="contain">
      <TreeSelect
        filter
        value={selectedName}
        selectionMode="single"
        expandedKeys={expandedKeys}
        id="lookuptreeviewCard"
       
        onChange={onSelectionChanged}
        options={data}
        className="md:w-20rem w-full"
        placeholder="Select name"
        onToggle={(e) => setExpandedKeys(e.value)}
      />
      {loading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "43%",
            transform: "translate(-50%, -50%)",
            zIndex: 1000, // Ensure the loader appears above other elements
          }}
        >
          <ProgressSpinner style={{ width: "50px", height: "30px" }} />
        </div>
      )}
    </div>
  );
}
